import React from 'react';
import { isIOSSafari, isStandalone } from '../utils/deviceDetection';
import './InstallAppButton.css';

interface InstallAppButtonProps {
  canInstallApp: boolean;
  isAppInstalled: boolean;
  onInstallApp: () => void;
  onShowIOSInstallInstructions?: () => void;
  language: 'de' | 'en';
}

export const InstallAppButton: React.FC<InstallAppButtonProps> = ({
  canInstallApp,
  isAppInstalled,
  onInstallApp,
  onShowIOSInstallInstructions,
  language
}) => {
  // Don't show if app is already installed
  if (isAppInstalled || isStandalone()) {
    return null;
  }

  // Don't show if it's not installable and not iOS Safari
  if (!canInstallApp && !isIOSSafari()) {
    return null;
  }

  const handleClick = () => {
    if (canInstallApp) {
      onInstallApp();
    } else if (isIOSSafari() && onShowIOSInstallInstructions) {
      onShowIOSInstallInstructions();
    }
  };

  const getButtonText = () => {
    if (canInstallApp) {
      return language === 'de' ? 'App installieren' : 'Install App';
    } else if (isIOSSafari()) {
      return language === 'de' ? 'App installieren' : 'Install App';
    }
    return '';
  };

  const getButtonDescription = () => {
    if (canInstallApp) {
      return language === 'de' ? 'Für Offline-Nutzung' : 'For offline use';
    } else if (isIOSSafari()) {
      return language === 'de' ? 'Anleitung anzeigen' : 'Show instructions';
    }
    return '';
  };

  return (
    <div className="install-app-button-container">
      <button 
        className="install-app-button"
        onClick={handleClick}
      >
        <span className="install-app-icon">📲</span>
        <div className="install-app-text">
          <div className="install-app-title">{getButtonText()}</div>
          <div className="install-app-description">{getButtonDescription()}</div>
        </div>
      </button>
    </div>
  );
};